import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";

import sqlFormatter from "sql-formatter";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {NotificationsService} from "angular2-notifications";

@Component({
	templateUrl: './report_queries.component.html'
})
export class ReporQueriesModalComponent extends InfoModalComponent {
	title: string = 'Loading...';
	queries: any[] = [];
	
	constructor(
		public activeModal: NgbActiveModal,
		public notifyService: NotificationsService,
	) {
		super(activeModal);
	}
	
	ok() {
		this.close();
	}
	
	copyToClipboard(sqlQuery) {
		const el = document.createElement('textarea');
		el.value = sqlFormatter.format(sqlQuery);
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
		
		this.notifyService.info('Copied!');
	};
}
